import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgV2RemoveSquare = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	"xmlns:svgjs": "http://svgjs.com/svgjs",
	viewBox: "0 0 16 16",
	width: 16,
	height: 16,
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Exported from Streamline App (https://app.streamlineicons.com)" }), /* @__PURE__ */ _jsxs("g", {
		transform: "matrix(0.6666666666666666,0,0,0.6666666666666666,0,0)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M 2.25,0.749h19.5c0.828,0,1.5,0.672,1.5,1.5v19.5c0,0.828-0.672,1.5-1.5,1.5H2.25c-0.828,0-1.5-0.672-1.5-1.5 v-19.5C0.75,1.421,1.422,0.749,2.25,0.749z ",
				stroke: "#000000",
				fill: "none",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 7.5,16.499l9-9 ",
				stroke: "#000000",
				fill: "none",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 16.5,16.499l-9-9",
				stroke: "#000000",
				fill: "none",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})]
});
export default SvgV2RemoveSquare;
